import React from 'react';
import {
  IPlanCode,
  IPromoCode,
  IRecurlyError,
} from '../../../utils/Interfaces';
import CouponSelector from '../../Upgrade/CouponSelector';
import styles from './PriceSummary.module.scss';
import { currency } from '../../../utils/currency';

const PRICE_SUMMARY_MESSAGES = {
  annual: 'Annual Subscription',
  seasonal: 'Seasonal Subscription',
  shippingLabel: 'Shipping*',
  promoCodeLabel: 'Promo Code',
  taxLabel: 'Tax',
  totalLabel: 'Total',
  labelCouponCode: 'Got a Coupon Code?',
};


export type PriceSummaryProps = {
  selectedPlanCode: string;
  planPrice: string;
  isLoadingPrices: boolean;
  totalPrice: string;
  shippingCost: string;
  taxCost: string;
  seasonMembershipName: string;
  discount: number;
  couponCodeConfig: {
    handleApplyCoupon: (couponCode: string) => void;
    handleRemoveCoupon: () => void;
    couponsApplied: IPromoCode[];
    couponError: {
      message: string;
    };
    discount: number;
    getCouponContentKey: (couponCode: string) => string;
    initialCouponCode?: string;
    setCouponError: (error: IRecurlyError | null) => void;
  };
};

const PriceSummary: React.FC<PriceSummaryProps> = ({
  selectedPlanCode,
  planPrice,
  totalPrice,
  shippingCost,
  taxCost,
  couponCodeConfig,
  seasonMembershipName,
  discount,
}) => {
  const {
    handleRemoveCoupon,
    couponError,
    handleApplyCoupon,
    couponsApplied,
    setCouponError,
  } = couponCodeConfig;

  const membershipName =
    selectedPlanCode === IPlanCode.ANNUAL
      ? PRICE_SUMMARY_MESSAGES.annual
      : PRICE_SUMMARY_MESSAGES.seasonal;

  return (
    <div className={styles.pricePlanSummary}>
      <div className={styles.priceHeadline}>
        <div>
          <p>{membershipName}</p>
          <p>
            1st Box - <span> {seasonMembershipName} </span>{' '}
          </p>
        </div>
        <p>{planPrice}</p>
      </div>
      <div className={styles.pricesPlanDetail}>
        <CouponSelector
          error={couponError}
          setCouponError={setCouponError}
          plan={selectedPlanCode}
          onRemoveCoupon={handleRemoveCoupon}
          customStyles={styles.couponCode}
          onApplyCoupon={handleApplyCoupon}
          couponsApplied={couponsApplied}
          inputLabel={PRICE_SUMMARY_MESSAGES.labelCouponCode}
          initialCouponCode={couponCodeConfig?.initialCouponCode}
        />
        {!!discount && (
          <>
            <div className={styles.itemPrice}>
              <p>{PRICE_SUMMARY_MESSAGES.promoCodeLabel}</p>
              <p>-{currency.format(discount)}</p>
            </div>
            <hr className={styles.itemPriceDivider} />
          </>
        )}
        <div className={styles.itemPrice}>
          <p>{PRICE_SUMMARY_MESSAGES.shippingLabel}</p>
          <p>{shippingCost}</p>
        </div>
        <hr className={styles.itemPriceDivider} />
        <div className={styles.itemPrice}>
          <p>{PRICE_SUMMARY_MESSAGES.taxLabel}</p>
          <p>{taxCost}</p>
        </div>
        <hr className={styles.itemPriceDivider} />
        <div className={styles.itemPrice}>
          <p>{PRICE_SUMMARY_MESSAGES.totalLabel}</p>
          <p>{totalPrice}</p>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
